<template>
  <div class="header-container" ref="headerContainer"
    :class="pageType.includes('solution') ? 'header-container1' : pageType === 'black' ? 'header-container2' : pageType=== 'fixed-write'? 'header-container-index' : ''">
    <div class="header flex flex-align-center flex-justify-between">
      <img src="@/assets/image/Slice 24@3x(1).png" class="logo"
        v-if="(pageType === 'index' || pageType === 'solution-write') && !isBlackLogo" @click="toHome" />
      <img src="@/assets/image/Slice 24@3x.png" class="logo logo222" v-else @click="toHome" />
      <ul class="flex flex-align-center">
        <li v-for="(item, index) in menuList" :key="index" @click="chooseMenu(index)" ref="menuItems"
          @mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeave(index)">{{ $t(item) }}</li>
        <li class="lang-switch" @click="toggleLang">
          {{ $i18n.locale === 'zh' ? 'EN' : '中' }}
        </li>
      </ul>
      <div class="submenu flex flex-justify-between flex-wrap" :class="{active: subStatus}" :style="submenuStyle" @mouseenter="subMouseenter"
        @mouseleave="subMouseleave">
        <div class="item" @click="toSecondPage(item, index)" v-for="(item, index) in subMenuList"
          :key="index">
          <div class="title">{{ $t(item.label) }}</div>
          <div class="txt">{{ $t(item.value) }}</div>
        </div>
      </div>
      <div class="submenu product flex flex-justify-between flex-wrap" :class="{active: productStatus}" :style="productStyle" @mouseenter="subMouseenter"
        @mouseleave="subMouseleave">
        <div class="item" @click="toSecondPage(item, index)" v-for="(item, index) in productList"
          :key="index">
          <div class="title">{{ $t(item.label) }}</div>
          <div class="txt">{{ $t(item.value) }}</div>
        </div>
      </div>
      <!-- <div class="kf-contain" v-if="kfStatus" :style="kfStyle" @mouseenter="kfMouseenter" @mouseleave="kfMouseleave">
        <div class="kf telegram flex flex-align-center" @click="openRandomLink(1)">
          <img src="@/assets/image/Slice 32@3x(3).png" />{{ $t('header.kf.telegram') }}
        </div>
        <div class="kf wechat flex flex-align-center" @click="openRandomLink(2)">
          <img src="@/assets/image/Slice 32@3x(4).png" />微信客服
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { openRandomLink } from '@/utils'
export default {
  name: 'headerComponent',
  props: {
    pageType: {
      type: String,
      default: () => 'index'
    }
  },
  data () {
    return {
      menuList: [
        'header.menu.home',
        'header.menu.products',
        'header.menu.solutions',
        'header.menu.announcements',
        'header.menu.contact'
      ],
      // menuIndex: 0,
      subStatus: false,
      timer: null,
      subMenuList: [
        { label: 'header.submenu.accountService', value: 'header.submenu.accountServiceDesc' },
        { label: 'header.submenu.dataAnalysis', value: 'header.submenu.dataAnalysisDesc' },
        { label: 'header.submenu.adDesign', value: 'header.submenu.adDesignDesc' },
        { label: 'header.submenu.adRejection', value: 'header.submenu.adRejectionDesc' },
        { label: 'header.submenu.optimization', value: 'header.submenu.optimizationDesc' },
        { label: 'header.submenu.qa', value: 'header.submenu.qaDesc' },
      ],
      productList: [
        { label: 'header.products.kuamao', value: 'header.products.kuamaoDesc', url: 'https://www.facebook123.com' },
        { label: 'header.products.eyou', value: 'header.products.eyouDesc', url: 'https://www.yiyufish.com'},
        { label: 'header.products.card', value: 'header.products.cardDesc', url: 'https://btreemint.com'},
      ],
      scrollPosition: '',
      isBlackLogo: false,
      kfStatus: false,
      timer1: null,
      menuIndex: 0,
      productStatus: false,
      submenuStyle: {},
      productStyle: {},
      kfStyle: {}
    }
  },
  methods: {
    openRandomLink: openRandomLink,
    toggleLang () {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
    },
    chooseMenu (index) {
      // this.menuIndex = index;
      if (index === 0) {
        this.$router.push({ path: '/' })
      } else if (index === 3) {
        this.$router.push({ path: '/announcement' })
      }else if (index === 4) {
        window.open('https://contact.bravotree.org/', '_blank')
      }
    },
    handleMouseEnter (index) {
      this.subStatus = false
      this.productStatus = false
      
      const li = this.$refs.menuItems[index];
      if (!li) return;
      const header = this.$el.querySelector('.header');
      const headerRect = header.getBoundingClientRect();
      const liRect = li.getBoundingClientRect();
      const offsetLeft = liRect.left - headerRect.left;
      const liWidth = liRect.width;

      if (index === 1) {
        this.menuIndex = index
        this.timer && clearTimeout(this.timer);
        this.productStatus = true
        // Center product submenu (width 300)
        let left = offsetLeft + liWidth / 2 - 300 / 2;
        this.productStyle = { left: left + 'px', right: 'auto' };
      }  else if (index === 2) {
        this.menuIndex = index
        this.timer && clearTimeout(this.timer);
        this.subStatus = true
        // Center solutions submenu (width 650)
        let left = offsetLeft + liWidth / 2 - 650 / 2;
        this.submenuStyle = { left: left + 'px', right: 'auto' };
      } else if (index === 4) {
        this.timer1 && clearTimeout(this.timer1);
        this.kfStatus = true
        // Align right edge of KF with right edge of "Contact Us" button
        // headerRect.right is absolute screen coordinate.
        // liRect.right is absolute screen coordinate.
        // But .header is relative container? No, .header-container is fixed.
        // .kf-contain is absolute in .header.
        // position: right = headerRect.right - liRect.right
        // Wait, .header width is calculated?
        // Let's assume right: (headerRect.right - liRect.right) + 'px'
        let right = headerRect.right - liRect.right;
        // ensure non-negative?
        if (right < 0) right = 0;
        this.kfStyle = { right: right + 'px', left: 'auto' };
      }
    },
    handleMouseLeave (index) {
      if (index === 1) {
        this.timer = setTimeout(() => {
          this.productStatus = false
        }, 300)
      } else if (index === 2) {
        this.timer = setTimeout(() => {
          this.subStatus = false
        }, 300)
      } else if (index === 4) {
        this.timer1 = setTimeout(() => {
          this.kfStatus = false
        }, 300)
      }
    },
    subMouseenter () {
      if (this.subStatus) {
        this.timer && clearTimeout(this.timer);
        this.subStatus = true
      }
      if (this.productStatus) {
        this.timer && clearTimeout(this.timer);
        this.productStatus = true
      }
    },
    subMouseleave () {
      console.log('4', 4)
      this.subStatus = false
      this.productStatus = false
    },
    kfMouseenter () {
      this.timer1 && clearTimeout(this.timer1);
      this.kfStatus = true
    },
    kfMouseleave () {
      this.kfStatus = false
    },
    handleScroll () {
      // 获取当前的滚动位置
      this.scrollPosition = window.scrollY;

      if (this.pageType === 'index') {
        if (this.scrollPosition > 100) {
          this.$refs.headerContainer.classList.add('header-container-index')
          this.isBlackLogo = true
        } else {
          this.$refs.headerContainer.classList.remove('header-container-index')
          this.isBlackLogo = false
        }
      } else if (this.pageType === 'write') {
        if (this.scrollPosition > 100) {
          this.$refs.headerContainer.classList.add('header-container-index')
        } else {
          this.$refs.headerContainer.classList.remove('header-container-index')
        }
      } else if (this.pageType !== 'fixed-write'){
        if (this.scrollPosition > 100) {
          this.isBlackLogo = true
          this.$refs.headerContainer.classList.add('header-container-index')
          this.$refs.headerContainer.classList.remove('header-container1')
        } else {
          this.isBlackLogo = false

          this.$refs.headerContainer.classList.remove('header-container-index')
          this.$refs.headerContainer.classList.add('header-container1')

        }

      }
      // 根据滚动位置执行特定的操作

    },
    toHome () {
      console.log('111', 111)
      this.$router.push('/')
    },
    toSecondPage (item, index) {
      if (item.url) {
        window.open(item.url, '_blank')
        return
      } else if (item.disabled) {
        this.$message({type: 'info',message: this.$t('header.message.stayTuned')});
        return
      }
      const name = '/solution' + (index + 1)
      if (name === this.$route.path) {
        window.scrollTo({
          top: 0,
          behavior: "smooth" // 平滑滚动
        });
      } else {
        this.$router.push(name)
      }
    }
  },
  mounted () {
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style lang="less" scoped>
.header-container {
  z-index: 10;
  position: fixed;
  z-index: 100;
  width: 100vw;
  left: 0;
  top: 0;
}

.home-bg {
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.header {
  width: calc(100vw - 300px);
  margin: 0 150px;
  position: relative;
  height: 90px;

  .logo {
    width: 186px;
    height: 59px;
  }

  ul {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 16px;
    color: #000000;

    li {
      /* width: 104px; */
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 50px 50px 50px 50px;
      cursor: pointer;
      margin-left: 10px;
      border: 1px solid transparent;
      white-space: nowrap;

      &:nth-last-child(2) {
        border: 1px solid #000000;
      }
    }

    .active {
      border: 1px solid #000000;
    }
  }
}

.header-container1 {
  ul {
    color: #fff;

    .active {
      border: 1px solid #fff;
    }
  }
}

/**.header-container2 {
  background: url('@/assets/image/header-bg.png') no-repeat center/100% 100%;
  height: 117px;
} **/

.header-container-index {
  background: url('@/assets/image/header-bg.png') no-repeat center/100% 100%;
  height: 117px;

  .header {
    padding-top: 0 !important;
  }
}

.submenu {
    position: absolute;
    top: 90px;
    right: 80px;
    width: 650px;
    background: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 20px 20px 20px 20px;
    padding: 46px 50px;
    opacity: 0;
    transform: translateY(10px);
    transition: opacity 0.6s cubic-bezier(0.25, 0.1, 0.25, 1), 
                transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1);
    will-change: opacity, transform;
    z-index: -1;
    pointer-events: none;
    .item {
      margin-bottom: 58px;
      width: 300px;
      cursor: pointer;
    }

    .title {
      font-family: Inter, Inter;
      font-weight: 600;
      font-size: 18px;
      color: #000000;
      line-height: 27px;
      margin-bottom: 10px;
    }

    .txt {
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 16px;
      color: #8C898E;
      line-height: 19px;
    }
  }
  .product{
    width: 300px;
    right: 206px;
    .item{
      &:nth-last-child(1){
        margin-bottom: 0;
      }
    }
  }
.active{
  opacity: 1; /* 鼠标移入：显示 */
  transform: translateY(0); /* 回到原位置 */
  z-index: 0;
  display: flex;
  pointer-events: auto;
}

.kf-contain {
  position: absolute;
  padding: 20px;
  right: 0;
  /* bottom: -130px; */
  bottom: -60px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);

  .kf {
    font-size: 18px;
    color: #000000;
    line-height: 40px;
    margin-bottom: 10px;
    cursor: pointer;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
[data-aos="fade-up"] {
  transform: translateY(20px) !important; /* 你可以改成 20px、50px */
}
</style>